import React, { ReactElement, useEffect } from 'react';
import * as S from './activate.styled';
import { ButtonColor, ButtonContainer } from '../../../../button';
import { useTranslations } from '../../../../translations';
import { IconFireComponent } from '../../../../icons';
import { useCustomersSubscriptionPopupContext } from '../../customersSubscriptionPopup.context';
import { setActivateSubscriptionPopupShown } from '../../customersSubscriptionPopup.helper';

export const Activate = (): ReactElement => {
  const translations = useTranslations();
  const { handleActivate } = useCustomersSubscriptionPopupContext();

  useEffect(() => {
    setActivateSubscriptionPopupShown();
  }, []);

  return (
    <S.Activate>
      <S.ActivateSticker>
        <span>NEW</span>
        <IconFireComponent />
      </S.ActivateSticker>
      <S.ActivateTitle>
        {translations.kcell_subscription_banner_title}
      </S.ActivateTitle>
      <S.ActivateLogo
        height={270}
        width={270}
        src="/img/courses_banners/girl_kz.png"
        alt="logo"
      />
      <ButtonContainer
        fullWidth
        onClick={handleActivate}
        title={translations.activate}
        color={ButtonColor.purple}
        borderRadius={100}
      />
    </S.Activate>
  );
};
